'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _watchAppNotifier = require('common/components/mixins/watch-app-notifier');

var _watchAppNotifier2 = _interopRequireDefault(_watchAppNotifier);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _formattedFaxNumber = require('common/components/formatted-fax-number');

var _formattedFaxNumber2 = _interopRequireDefault(_formattedFaxNumber);

var _tooltip = require('common/components/tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

var _multiSelect = require('common/components/multi-select');

var _multiSelect2 = _interopRequireDefault(_multiSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx('br', {});

var FaxLineConfigEntry = _react2['default'].createClass({
    displayName: 'FaxLineConfigEntry',


    mixins: [_watchAppNotifier2['default']],

    propTypes: {
        hasMultiple: _react2['default'].PropTypes.bool.isRequired,
        teamMembers: _react2['default'].PropTypes.array.isRequired, // This should be allTeamMembers
        faxLine: function faxLine(props, propName, componentName) {
            if (props[propName].number === undefined) {
                throw new Error(propName + ".number must be defined for " + componentName);
            }
            if (props[propName].statusCode === undefined) {
                throw new Error(propName + ".statusCode must be defined for " + componentName);
            }
            if (props[propName].guid === undefined) {
                throw new Error(propName + ".guid must be defined for " + componentName);
            }

            if (props[propName].selectedTeamMemberGuids === undefined) {
                throw new Error(propName + ".selectedTeamMemberGuids must be defined for " + componentName);
            }
            if (!Array.isArray(props[propName].selectedTeamMemberGuids)) {
                throw new Error(propName + ".selectedTeamMemberGuids must be an Array for " + componentName);
            }
        }
    },

    getInitialState: function getInitialState() {
        return {
            hasHover: false,
            isDeleting: false,
            statusMessage: null, // when not null, should be object in form of { text: "", className: "" }
            isPorting: this.props.faxLine.statusCode !== _hfReactHelper2['default'].HfConstants.team_fax_lines.STATUS_CODES.STATUS_CODE_ACTIVE
        };
    },

    handleMouseEnter: function handleMouseEnter() {
        this.setState({ hasHover: true });
    },

    handleMouseLeave: function handleMouseLeave() {
        this.setState({ hasHover: false });
    },

    handleDelete: function handleDelete() {
        if (!window.confirm("Are you sure you want to " + (this.state.isPorting ? "cancel porting for this number?" : "remove this fax line? You will no longer be able to receive faxes at this number."))) {
            return;
        }

        this.setState({ isDeleting: true });
        this.props.faxLine.remove();
    },

    handleSelectionChange: function handleSelectionChange(selectedTeamMemberGuids) {

        if (selectedTeamMemberGuids.length === 0) {
            this.setState({
                statusMessage: {
                    text: "Cannot save. At least one recipient is required.",
                    className: "error"
                }
            });
        } else {
            var onResult = function onResult(err, result) {
                if (!err) {
                    this.setState({ statusMessage: { text: "Saved", className: "success" } });
                } else {
                    this.setState({ statusMessage: { text: "Error. Could not save.", className: "" } });
                }
            };

            this.props.faxLine.setMembers(this.props.teamMembers.filter(function (tm) {
                return !! ~selectedTeamMemberGuids.indexOf(tm.guid);
            })).then(onResult.bind(this, void 0), onResult.bind(this));
        }
    },

    render: function render() {
        var hintText;
        var hintMsg;

        if (this.props.faxLine.isDenied()) {
            hintMsg = _jsx('span', {}, void 0, 'Thank you for your interest in switching over to HelloFax! Unfortunately, we are unable to port this number at this time.');
            hintText = _jsx('span', {}, void 0, 'Porting not possible', _jsx(_tooltip2['default'], {
                content: hintMsg,
                text: '?',
                arrowPosition: 'left'
            }));
        } else if (this.props.faxLine.isPorting()) {
            hintText = _jsx('span', {}, void 0, 'Checking portability');
        } else if (this.props.faxLine.isAccepted()) {
            hintMsg = _jsx('span', {}, void 0, _jsx('b', {}, void 0, 'Your number is portable!'), _ref, 'Please check your email for the steps to complete your porting request.');
            hintText = _jsx('span', {}, void 0, 'Porting in progress', _jsx(_tooltip2['default'], {
                content: hintMsg,
                text: '?',
                arrowPosition: 'left'
            }));
        } else if (this.props.faxLine.isActive()) {
            hintText = _jsx('span', {}, void 0, 'Email inbound faxes to:');
        }

        var deleteBtn = null;
        if (true || this.props.faxLine.statusCode === _hfReactHelper2['default'].HfConstants.team_fax_lines.STATUS_CODES.STATUS_CODE_PORTING_STARTED || this.props.hasMultiple && (this.state.hasHover || this.state.isDeleting)) {
            deleteBtn = _jsx('span', {
                onClick: this.handleDelete,
                className: "remove-fax-line" + (this.state.isDeleting ? " loading" : ""),
                'data-fax-line-guid': this.props.faxLine.guid,
                'data-fax-number': this.props.faxLine.number
            }, void 0, _jsx('img', {
                className: 'spinner',
                src: _hfReactHelper2['default'].HfConstants.team_fax_lines.URLS.spinnerUrl,
                width: '16',
                height: '16'
            }));
        }

        var disabled = _hfReactHelper2['default'].inArray(this.props.faxLine.statusCode, [_hfReactHelper2['default'].HfConstants.team_fax_lines.STATUS_CODES.STATUS_CODE_PORTING_DENIED, _hfReactHelper2['default'].HfConstants.team_fax_lines.STATUS_CODES.STATUS_CODE_PORTING_DENIED]) > -1;

        return _jsx('div', {
            className: "fax_line_select status-" + this.props.faxLine.statusCode,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave
        }, void 0, _jsx('h4', {}, void 0, _jsx('span', {}, void 0, _jsx(_formattedFaxNumber2['default'], {
            faxNumber: this.props.faxLine.number
        }), " - ", _jsx('span', {
            className: 'text'
        }, void 0, hintText)), deleteBtn), _react2['default'].createElement(_multiSelect2['default'], { ref: 'multiSelect',
            className: 'fax_line_select',
            disabled: disabled,
            statusMessage: this.state.statusMessage,
            options: this.props.teamMembers.map(function (teamMember, i) {
                return { key: teamMember.guid, descr: teamMember.emailAddress };
            }),
            onSelectionChange: this.handleSelectionChange,
            initiallySelectedOptionValues: this.props.faxLine.teamMembers.map(function (v) {
                return v.guid;
            }),
            'data-fax-line-guid': this.props.faxLine.guid }));
    }
});

module.exports = FaxLineConfigEntry;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/app/content/team/team-fax-lines/config-entry.jsx
 ** module id = 806
 ** module chunks = 0
 **/